import DesingerLead from "../views/leads/DesingerLead"
import ConsultetionLead from "../views/leads/ConsultationLead"
import PartnerLead from "../views/leads/PartnerLead"


var routes = [
    {
        path: '/desinger-leads',
        name: "DesingerLead",
        component: DesingerLead
    },
    {
        path: '/consultetion-leads',
        name: "ConsultetionLead",
        component: ConsultetionLead
    },
    {
        path: '/partner-leads',
        name: "PartnerLead",
        component: PartnerLead
    },
]

export default routes